import { AuthActionType } from 'pages/Auth/constants'
import { USER_PROP } from 'pages/User/constants'

export const getDefaultState = () => ({
    loggedIn: false,
    fetching: true,
    role: '',
    register: {
        [USER_PROP.EMAIL]: '',
        [USER_PROP.FNAME]: '',
        [USER_PROP.LNAME]: '',
        [USER_PROP.PASSWORD]: '',
        [USER_PROP.ROLE]: '',
        [USER_PROP.AFFILIATION]: '',
        [USER_PROP.TITLE]: '',
        inviteType: '',
    },
    two_factor_auth: {
        email: '',
        verified: false,
        required: false,
    },
    user: {
        firstname: '',
        lastname: '',
        email: '',
    }
})

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case AuthActionType.SET_AUTH:
            return setAuth(state, action)
        case AuthActionType.SET_FETCHING:
            return setFetching(state, action)
        case AuthActionType.SET_ROLE:
            return setRole(state, action)
        case AuthActionType.SET_REGISTRATION:
            return setRegistration(state, action)
        case AuthActionType.SET_VERIFIED:
            return setVerified(state, action)
        case AuthActionType.AUTH_ERROR:
            return setAuthState(state, action)
        case AuthActionType.SET_TWO_FACTOR_AUTH:
            return setTwoFactorAuth(state, action)
        case AuthActionType.SET_USER_DATA:
            return setUserData(state, action)
        case AuthActionType.SET_INVITE_DATA:
            return {
                ...state,
                register: {
                    ...state.register,
                    role: action.data.role,
                    email: action.data.email || '',
                    inviteType: action.data.type,
                },
            }
        case AuthActionType.RESET_DATA:
            return {
                ...state,
                ...getDefaultState()
            }
        default:
            return state
    }
}
const setFetching = (state, { fetching }) => {
    return {
        ...state,
        fetching,
    }
}

const setAuth = (state, { loggedIn }) => {
    return {
        ...state,
        loggedIn,
        fetching: false,
    }
}

const setRole = (state, { role }) => {
    return {
        ...state,
        role,
    }
}

const setRegistration = (state, { register }) => {
    return {
        ...state,
        register,
    }
}

const setAuthState = (state, { payload: { error } }) => {
    return {
        ...state,
        showResendEmail: error,
    }
}

const setVerified = (state, { payload: { verified } }) => {
    return {
        ...state,
        verified: verified,
    }
}

const setTwoFactorAuth = (state, { email, verified, required }) => {
    return {
        ...state,
        two_factor_auth: {
            email,
            verified,
            required,
        },
    }
}


const setUserData = (state, { user }) => {
    return {
        ...state,
        user: {
            ...state.user,
            ...user,
        },
    }
}